<template>
    <div class="card mt-2 mb-2" @click="clickCampaign()">
        <img :src="campaign.fullImageUrl" class="card-img-top" />
        <div class="card-body">
            <strong>{{campaign.name}}</strong>
            <div>{{getPointMessage()}}</div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"

export default {
    name: 'CampaignItem',
    props: {
        lbl: Object,
        index: Number,
        campaign: Object
    },
    data: function() {
        return {
            lblCampaign: this.lbl.campaign
        };
    },
    created: function() {

    },
    mounted: function () {
        //this.lblCampaign = this.lbl.campaign;
    },
    methods: {
        //event
        clickCampaign: function () {
            //GA
            var path = '/keepalive/' + this.campaign.id;
            this.$router.push(path);
        },
        //method
        isSoldOut: function () {
            return this.campaign.qty < 1
                ? true
                : false
        },
        //utility
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lblCampaign.get_point : this.lblCampaign.use_point;
            var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
